var render, staticRenderFns
import script from "./EzTable.vue?vue&type=script&lang=js&"
export * from "./EzTable.vue?vue&type=script&lang=js&"
import style0 from "./EzTable.vue?vue&type=style&index=0&id=4a573b63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a573b63",
  null
  
)

export default component.exports